import { Author, FALLBACK_AUTHOR, User } from '../../types/User';

export const userToAuthor = (authorData: User | null | undefined): Author => {
    if (!authorData) {
        return FALLBACK_AUTHOR;
    }

    return {
        id: authorData.id,
        name: `${authorData.firstname} ${authorData.lastname}`,
        profilePicture: authorData.profilePicture,
        jobTitle: authorData.jobTitle,
        institution: authorData.institution,
        pronouns: authorData.pronouns,
        firstname: authorData.firstname,
        lastname: authorData.lastname
    };
};
